import{createPluginCenter as e,request as t,markdown as o}from"@topwrite/core";export{BaseConfig,Book,Config,File,LetterAvatar,Level,Summary,SummaryArticle,SummaryPart,aes,isEncryptedData,isRequestError,isUrl,markdown,md5,pluginCenter,request}from"@topwrite/core";import n from"url";import{jsx as r,Fragment as i,jsxs as c}from"react/jsx-runtime";import a,{Suspense as s,Fragment as l,Component as d,useMemo as u,createElement as m,useState as h,useCallback as p,useEffect as f,createContext as g,useContext as b,useRef as w,Children as v}from"react";import x from"@babel/runtime/helpers/defineProperty";import{useSelector as k,Model as y,createStore as E,Provider as C,useActions as $}from"@topthink/redux-model";export{Model}from"@topthink/redux-model";import S from"loadjs";export{default as loadjs}from"loadjs";import P from"query-string";import M,{createGlobalStyle as j}from"styled-components";export{ThemeProvider,createGlobalStyle,css,keyframes,default as styled}from"styled-components";import{createIntlCache as z,createIntl as L,RawIntlProvider as D}from"react-intl";export{IntlContext,defineMessage,defineMessages,useIntl}from"react-intl";import A from"remark-slug";import{toc as T}from"mdast-util-toc";import{all as I,toHast as _}from"mdast-util-to-hast";import{convert as O}from"unist-util-is";import{toString as F}from"mdast-util-to-string";import{encode as N}from"mdurl";import W from"html-tags";import{debounce as U,throttle as q}from"lodash";export{default as useEvent}from"@react-hook/event";export{useHotkeys}from"react-hotkeys-hook";export{useAsync,useAsyncCallback,useAsyncFetchMore}from"react-async-hook";export{Helmet}from"react-helmet";window.TopWritePlugins={};class H extends HTMLElement{connectedCallback(){this.addEventListener("click",(e=>{if(e.preventDefault(),!this.isContentEditable){const e=this.attributes.getNamedItem("src");let t=e?.value;if(t){let e=document.createElement("a");e.download=this.textContent||"",e.style.display="none",e.target="_blank",e.href=n.resolve(location.href,t),document.body.appendChild(e),e.click(),document.body.removeChild(e)}}}))}}function V(e){let{component:t,defaultComponent:o=l,props:n,children:i=null,context:c}=e;return null===t?null:r(s,{fallback:null,children:r(t,{props:n,Component:o,context:c,children:i})})}customElements.define("t-attachment",H);class B extends d{constructor(){super(...arguments),x(this,"state",{hasError:!1})}componentDidCatch(){this.setState({hasError:!0})}render(){return this.state.hasError?null:this.props.children}}var R=(e,t)=>e.filter((e=>{let{descriptor:o}=e;return t===o.role})).sort(((e,t)=>{let{descriptor:{priority:o=0}}=e,{descriptor:{priority:n=0}}=t;return o-n})).map((e=>{return t=e.Component,e=>r(B,{children:r(t,{...e},"WrappedComponent")});var t}));function G(e){let{component:t,props:o}=e;return m(t,o)}function J(e){let{props:t,role:o,component:n,context:i}=e;const c=n?r(G,{component:n,props:t,context:i}):null,a=k("components");return u((()=>R(a,o)),[a,o]).reduce(((e,o)=>r(V,{defaultComponent:n,component:o,props:t,context:i,children:e})),c)}function K(e){let{props:t,component:o,role:n,context:c}=e;const a=k("components"),s=u((()=>R(a,n)),[a,n]);return r(i,{children:s.map(((e,n)=>r(V,{defaultComponent:o,component:e,props:t,context:c},n)))})}async function Q(e){let t=`topwrite-plugin-${e.name}`;if(!S.isDefined(t)){let o=`${e.host}/${e.main}`;try{await S(o,t,{returnPromise:!0})}catch{console.warn(`插件${e.name}加载失败`)}}}function X(e,t){let o;return o=t instanceof Array?{Component:t[0],descriptor:{role:e,...t[1]}}:{Component:t,descriptor:{role:e}},o}function Y(){const e=k("book");if(!e)throw new Error("book object not initialized");return e}const Z="localStorage";function ee(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Z;if("undefined"==typeof window)throw new Error("Browser storage is not available on NodeJS / TopWrite SSR process");if("none"===e)return null;try{return window[e]}catch(e){return null}}const te={get:()=>null,set:()=>{},del:()=>{}},oe=(e,t)=>{const o=ee(t?.persistence);return null===o?te:{get:()=>o.getItem(e),set:t=>o.setItem(e,t),del:()=>o.removeItem(e)}};function ne(){const e=ee(arguments.length>0&&void 0!==arguments[0]?arguments[0]:Z);if(!e)return[];const t=[];for(let o=0;o<e.length;o+=1){const n=e.key(o);null!==n&&t.push(n)}return t}function re(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";const o=u((()=>oe(e)),[e]),[n,r]=h((()=>o.get()||t)),i=p((e=>{r(e),e===t?o.del():o.set(e)}),[o]);return f((()=>{const o=o=>{o.key===e&&r((e=>o.newValue!==e?o.newValue||t:e))};return window.addEventListener("storage",o),()=>window.removeEventListener("storage",o)}),[e]),[n,i]}const ie={light:"light",dark:"dark"},ce=e=>e===ie.dark?ie.dark:ie.light,ae=window.matchMedia?window.matchMedia("(prefers-color-scheme: dark)"):void 0,se=()=>ae?.matches?ie.dark:ie.light,le=e=>{document.documentElement.setAttribute("data-theme",e)},de=g(void 0);function ue(e){let{children:t,context:o,theme:n}=e;const i=Y(),[c,a]=re(`${o}.${i.id}.theme`,"auto"),[s,l]=h((()=>{let e;return e=n||"auto"!==c?ce(n||c):se(),e}));f((()=>{if(ae&&!n&&"auto"===c){const e=e=>{e.matches?l(ie.dark):l(ie.light)};return ae.addEventListener("change",e),()=>{ae.removeEventListener("change",e)}}}),[c,n]),f((()=>{l("auto"==c?n||se():ce(c))}),[c]),f((()=>{le(s)}),[s]);const d=p((()=>{a(ie.light)}),[]),u=p((()=>{a(ie.dark)}),[]),m=p((()=>{a("auto")}),[]),g=p((()=>{"auto"===c?d():s===ie.light?u():m()}),[s,c,d,u]);return r(de.Provider,{value:{theme:s,isAutoTheme:"auto"===c,isDarkTheme:s===ie.dark,setLightTheme:d,setDarkTheme:u,setAutoTheme:m,toggleTheme:g},children:t})}function me(){const e=b(de);if(!e)throw new Error("theme context not exist");return e}const he=j`
    :root {
        --ttw-color: #333;
        --ttw-primary-color: #3c60ff;
        --ttw-secondary-color: #9e9e9e;
        --ttw-gray-color: rgba(0, 0, 0, 0.5);
        --ttw-background: #fff;
        --ttw-border-color: #eaeaea;
        --ttw-box-color: #212529;
        --ttw-box-background: #FFF;
        --ttw-box-hover-background: #e9ecef;
        --ttw-box-active-background: #f1f2f2;
    }

    [data-theme=dark] {
        --ttw-color: #cacbcf;
        --ttw-secondary-color: #888;
        --ttw-gray-color: rgba(255, 255, 255, 0.5);
        --ttw-background: #1F2428;
        --ttw-border-color: #1B1F23;
        --ttw-box-color: #e1e4e8;
        --ttw-box-background: #2f363d;
        --ttw-box-hover-background: #39414a;
        --ttw-box-active-background: #242A30;
    }
    
    //TODO 转移到异步加载
    //附件
    t-attachment {
        color: var(--ttw-primary-color, #3c60ff);
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        padding: 0 4px;
        vertical-align: bottom;
        margin: 0 1px;

        &:before {
            content: '';
            width: 18px;
            height: 18px;
            background-color: var(--ttw-primary-color, #3c60ff);
            mask: url("${"data:image/svg+xml,%3csvg t='1642406480574' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2254' width='16' height='16'%3e %3cpath d='M874.666667 467.2c-10.666667-10.666667-29.866667-12.8-42.666667 0l-343.466667 341.333333c-74.666667 74.666667-198.4 74.666667-275.2 0-36.266667-36.266667-57.6-85.333333-57.6-136.533333s19.2-100.266667 57.6-136.533333L556.8 192c46.933333-46.933333 121.6-46.933333 168.533333 0 23.466667 23.466667 34.133333 53.333333 34.133334 83.2 0 32-12.8 61.866667-34.133334 83.2L384 704c-17.066667 17.066667-44.8 17.066667-64 0-8.533333-8.533333-12.8-19.2-12.8-32s4.266667-23.466667 12.8-32l317.866667-315.733333c10.666667-10.666667 12.8-29.866667 0-42.666667-10.666667-12.8-29.866667-12.8-42.666667 0L277.333333 597.333333c-19.2 19.2-29.866667 46.933333-29.866666 74.666667S258.133333 725.333333 277.333333 746.666667c40.533333 40.533333 106.666667 40.533333 147.2 0L768 403.2c34.133333-34.133333 53.333333-78.933333 53.333333-125.866667s-19.2-93.866667-53.333333-125.866666a178.986667 178.986667 0 0 0-253.866667 0l-341.333333 341.333333c-46.933333 46.933333-74.666667 110.933333-74.666667 179.2s25.6 132.266667 74.666667 179.2c49.066667 49.066667 115.2 74.666667 179.2 74.666667s130.133333-25.6 179.2-74.666667l343.466667-341.333333c10.666667-12.8 10.666667-32 0-42.666667z' p-id='2255'%3e%3c/path%3e%3c/svg%3e"}") no-repeat center;
            margin-right: 4px;
        }

        &:after {
            content: "(" attr(size) ")";
            margin-left: 4px;
            display: none;
        }

        &[size]:after {
            display: inline;
        }

        &:hover {
            background: rgba(0, 0, 0, .1);
        }

        &:read-write {
            cursor: text;
        }
    }
`;const pe=new class extends y{constructor(){super(...arguments),x(this,"initialState",[])}*register(e){yield this.setState((t=>t.push(e)))}};const fe=new class extends y{};var ge=Object.freeze({__proto__:null,components:pe,options:fe});const be=g(void 0),we=()=>{const e=b(be);if(void 0===e)throw new Error("useIntlContext must be used within a Layout component");return e},ve=e=>{let{children:t}=e;const{locale:o,messages:n}=we(),i=u((()=>{const e=z();return L({locale:o,messages:n,defaultLocale:"en"},e)}),[o,n]);return r(D,{value:i,children:t})},xe=e=>{let{children:t,locale:o,messages:n}=e;const[i,c]=h(n);return r(be.Provider,{value:{locale:o,messages:i,setMessages:c},children:r(ve,{children:t})})};function ke(e){return e.__esModule&&e.default?e.default:e}class ye{constructor(e,t,o){x(this,"name",void 0),x(this,"book",void 0),x(this,"models",{...ge}),x(this,"components",[]),x(this,"activates",[]),x(this,"plugins",[]),x(this,"initialState",void 0),this.name=e,this.book=t,this.initialState=o}registerComponents(e,t){for(let[o,n]of Object.entries(e))n&&("plugin:setting"===o&&(o=`plugin:setting:${t}`),this.components.push(X(o,n)))}registerModels(e,t){for(const[o,n]of Object.entries(e))t?this.models[`@${t}@${o}`]=n:this.models[o]=n}async registerPlugins(e){this.plugins=e;for(const t of e)try{this.registerComponents(t.components,t.name),this.registerModels(t.models,t.name),t.activate&&this.activates.push(t.activate),t.register&&await t.register(this.name,this.book)}catch(e){console.log(e)}}async createApp(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:navigator.language,o=arguments.length>2?arguments[2]:void 0;t=this.detectLocale(t);const n=await this.loadMessages(t,e),a=E(this.models,{book:this.book,components:this.components,...this.initialState}),s=e=>{let{children:t}=e;return r(i,{children:t})},l=e=>{let{children:t}=e;const o=r(J,{role:`activate:${this.name}`,props:{children:t,name:this.name},component:s});return this.activates.reduce(((e,t)=>{const o=t(this.name);return void 0!==o?r(i,{children:o}):e}),o)};return e=>{let{children:i}=e;return r(C,{store:a,children:c(ue,{context:this.name,theme:o,children:[r(he,{}),r(xe,{locale:t,messages:n,children:r(l,{children:i})})]})})}}detectLocale(e){const t=oe(`${this.name}.${this.book.id}.lang`);e=t.get()||e;const o=new URLSearchParams(window.location.search).get("lang");return o&&(t.set(o),e=o),document.documentElement.setAttribute("lang",e),e}async loadMessages(e,t){return await this.plugins.reduce((async(t,o)=>{const n=ke(await t);return o.localize?Object.assign({},n,ke(await o.localize(e))):n}),t(e))}}async function Ee(o){const{name:n,book:r,models:i,initialState:c,localize:a,pluginCenter:s,locale:l,theme:d}=o,u=await async function(o,n){let r=[];if(n){const t=e(n);try{r=await t.getInstalled(o),r=r.filter((e=>!window.TopWritePlugins[e.name]?.meta))}catch{}}try{const e=sessionStorage.getItem("PLUGIN_DEV"),o=P.parse(window.location.search);if("dev"in o||e){const n=o.dev||e||8080;try{const e=(await t.get(`http://localhost:${n}/meta`)).data;r=r.filter((t=>t.name!==e.name&&!("theme"===e.type&&"theme"===t.type))),window.TopWritePlugins[e.name]&&delete window.TopWritePlugins[e.name],r.unshift(e),sessionStorage.setItem("PLUGIN_DEV",String(n))}catch(e){console.warn(e),sessionStorage.removeItem("PLUGIN_DEV")}}}catch{}const i=Object.entries(window.TopWritePlugins).filter((e=>{let[,t]=e;return!!t.meta})).map((e=>{let[,t]=e;return t.meta})),c=i.some((e=>"theme"===e.type)),a=Object.keys(window.TopWritePlugins),s=[];for(let e of r)e.disabled||a.includes(e.name)||c&&"theme"===e.type||s.push(Q(e));return await Promise.all(s),i.push(...r),window.TopWritePluginsMeta=i,Object.values(window.TopWritePlugins||{})}(r,s),m=new ye(n,r,c);return m.registerModels(i),await m.registerPlugins(u),await m.createApp(a,l,d)}function Ce(e){return $(e)}function $e(e){return k(e)}function Se(e){return[$e(e),Ce(e)]}function Pe(e,t,o){const n="function"==typeof t;n||(o=t),f((()=>{let o;const r=e();return Promise.resolve(r).then((e=>{o=e})),()=>{n&&t(o)}}),o)}function Me(e){const t=w(null),[o,n]=h(e);f((()=>{t.current&&(t.current(),t.current=null)}),[o]);return[o,(e,o)=>{t.current="function"==typeof o?o:null,n(e)}]}function je(){const e=document.currentScript;if(!e)throw new Error("Automatic publicPath is not supported in this browser");return e.src.replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/")}class ze{constructor(e){let{name:t,meta:o,models:n={},components:r={},activate:i,register:c,localize:a,config:s}=e;x(this,"name",void 0),x(this,"config",void 0),x(this,"localize",void 0),x(this,"models",void 0),x(this,"components",void 0),x(this,"activate",void 0),x(this,"register",void 0),x(this,"meta",void 0),this.name=t,this.meta=o,this.models=n,this.components=r,this.activate=i,this.register=c,this.localize=a,this.config=s}}const Le=g({}),De=Le.Provider,Ae=()=>b(Le);function Te(e,t){return Ae()[e]||t}const Ie=O("root"),_e=O("element"),Oe=O("text");function Fe(e){return e.filter((e=>!(Oe(e)&&"\n"===e.value)))}function Ne(e,t,o){const n=t.properties,r=t.tagName,i={...n};o.prefix&&(o.key++,i.key=o.prefix+o.key);const c=[],a=Fe(t.children),s=a?a.length:0;let l=-1;for(;++l<s;){const t=a[l];_e(t)?c.push(Ne(e,t,o)):Oe(t)&&c.push(t.value)}return e.call(t,r,i,c.length>0?c:void 0)}function We(e,t){let{extensions:o=[],creator:n=a.createElement}=t;const r={allowDangerousHtml:!1,handlers:{...o.reduce(((e,t)=>Object.assign(e,t)),{}),textDirective:(e,t)=>e({},"textDirective",{name:t.name,attributes:t.attributes},I(e,t)),leafDirective:(e,t)=>e({},"leafDirective",{name:t.name,attributes:t.attributes},I(e,t)),containerDirective(e,t){"children"in t||(t.children=[]);let o=!1;for(const e of t.children)if(e.data?.directiveLabel){o=!0;break}return o||t.children.unshift({type:"paragraph",children:[{type:"text",value:""}]}),e({},"containerDirective",{name:t.name,attributes:t.attributes},I(e,t))},heading(e,t){const o=e(t,"heading",I(e,t));return o.properties={...o.properties,depth:t.depth},o}},unknownHandler:()=>null},i=_(e,r);if(Ie(i))return Fe(i.children).map(((e,t)=>_e(e)?Ne(n,e,{key:0,prefix:`h-${t}-`}):Oe(e)?e.value:void 0));if(!_e(i))throw new Error("Expected root or element, not `"+(i&&i.type||i)+"`");return Ne(n,i,{key:0,prefix:"h-"})}function Ue(e){let{extensions:t,tree:o,options:n}=e;const a=u((()=>{let e=null;if(n){const r=T(o).map;r&&(e=We(r,{extensions:[...t,{link:(e,t)=>{const o=F(t.children);return e(t,"a",{href:N(t.url)},[{type:"text",value:o}])}}]})),"object"==typeof n&&(e=c(i,{children:[n.header,e,n.footer]}))}return e}),[t,o,n]);return a?r("aside",{children:a}):null}const qe=e=>{let{value:t}=e;return r("pre",{children:r("code",{children:t})})},He=e=>{let{value:t}=e;return r("code",{children:t})};const Ve=["video","audio"];function Be(e){const{name:t,attributes:o,children:n}=e;let i=Te(t),c=`html:${t}`;return customElements.get(`t-${t}`)?i=i||`t-${t}`:Ve.includes(t)||(i=void 0,c=`directive:${t}`),r(J,{role:c,props:{...o,children:n},component:i})}function Re(e){let{depth:t=5,...o}=e;return m(`h${t}`,o)}const Ge={"x-inline":function(e){const{name:t,value:o}=e;return r(J,{role:`inline:${t}`,props:{type:"inline",name:t,value:o},component:He})},"x-block":function(e){const{name:t,value:o,parameter:n}=e;return r(J,{role:`block:${t}`,props:{type:"block",name:t,parameter:n,value:o},component:qe})},textDirective:Be,leafDirective:Be,containerDirective:function(e){let{name:t,attributes:o,children:n}=e,i=Te(t),c=`html:${t}`;const[a,...s]=v.toArray(n),l={children:s,label:a,...o};return customElements.get(`t-${t}`)?i=i||`t-${t}`:Ve.includes(t)||(i=void 0,c=`directive:${t}`),r(J,{role:c,props:l,component:i})},heading:function(e){const t=Te("heading",Re);return r(J,{role:"html:heading",props:e,component:t})}},Je=e=>{let{tagName:t,inject:o=!0,...n}=e;const i=Te(t,t);return o?Ge[t]?m(Ge[t],n):W.includes(t)?r(J,{role:`html:${t}`,props:n,component:i}):(console.warn(`unknown tagName: ${t}`),null):m(i,n)};function Ke(e){let{tree:t,extensions:o,as:n,css:i,header:a,footer:s,inject:l}=e;const d=u((()=>We(t,{extensions:o,creator:(e,t,o)=>m(Je,{...t,tagName:e,inject:l},o)})),[t,o]);return c("article",{children:[a,r(Qe,{$css:i,as:n,children:d}),s]})}const Qe=M.section`
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    line-height: 1.2;
    word-wrap: break-word;

    & > *:first-child {
        margin-top: 0 !important;
    }

    & > *:last-child {
        margin-bottom: 0 !important;
    }

    h1, h2, h3, h4, h5, h6, p, ul, ol, blockquote, pre, table, audio, video {
        margin-top: 0;
        margin-bottom: 1rem;
        line-height: 1.5;
        padding: 0;

        &:last-child {
            margin-bottom: 0 !important;
        }

        &:first-child {
            margin-top: 0 !important;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-weight: 500;
        margin-top: 2rem;
        margin-bottom: 1rem;
        line-height: 1.2;

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    h1 {
        font-size: 2.5em;
    }

    h2 {
        font-size: 2em;
    }

    h3 {
        font-size: 1.75em;
    }

    h4 {
        font-size: 1.5em;
    }

    h5 {
        font-size: 1.25em;
    }

    hr {
        border: 0;
        border-bottom: 1px solid #eeeeee;
        margin-bottom: 0.5em;
    }

    ul {
        padding-left: 2em;

        ul {
            margin: 0;
        }
    }

    ol {
        padding-left: 2em;
    }

    li {
        line-height: 2;

        &.task-list-item {
            list-style: none;
            position: relative;

            input[type=checkbox] {
                position: absolute;
                left: -1.5em;
                top: 0.5em;
                width: 1em;
                height: 1em;
            }
        }

        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    code {
        display: inline-block;
        border-radius: 4px;
        padding: .2em .4em;
        background-color: #f7f7f7;
        word-break: break-all;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        white-space: pre;
        line-height: 1.3;
        color: inherit;
        font-size: inherit;
        margin: -.2em .4em;
    }

    pre {
        padding: 1.05em;
        overflow: auto;
        line-height: 1.45;
        background-color: #f7f7f7;
        border: 0;
        border-radius: 3px;
        font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
        font-size: inherit;
    }


    pre > code {
        display: inline;
        max-width: 100%;
        padding: 0;
        margin: 0;
        overflow: initial;
        line-height: inherit;
        background-color: rgba(0, 0, 0, 0);
        border: 0;
        tab-size: 4;
    }

    p {
        &.align-right {
            text-align: right;
        }

        &.align-center {
            text-align: center;
        }
    }

    table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
        line-height: 1.8;
        border-spacing: 0;

        th {
            text-align: left;

            &[align='center'] {
                text-align: center;
            }

            &[align='right'] {
                text-align: right;
            }
        }

        th, td {
            border: 1px solid #e0e0e0;
            padding: 3px 12px;
            height: 34px;
        }

        tr:hover td {
            background-color: #f1f1f1;
        }
    }

    img {
        max-width: 100%;
        display: inline-block;
        padding: 3px;
        vertical-align: middle;
    }

    a {
        text-decoration: none;
        color: var(--ttw-primary-color, #3c60ff);

        &:hover {
            text-decoration: underline;
        }
    }

    blockquote {
        padding: 5px 5px 5px 15px;
        color: #858585;
        border-left: 4px solid #e5e5e5;

        &.info {
            border-left-color: #5bc0de;
            color: #5bc0de;
            background-color: #f4f8fa;
        }

        &.warning {
            background-color: #fcf8f2;
            border-color: #f0ad4e;
            color: #f0ad4e;
        }

        &.danger {
            color: #d9534f;
            background-color: #fdf7f7;
            border-color: #d9534f;
        }

        &.success {
            background-color: #f3f8f3;
            border-color: #50af51;
            color: #50af51;
        }
    }

    video {
        display: block;
        width: 100%;
    }

    audio {
        display: block;
        width: 100%;
    }

    [data-theme=dark] & {
        code {
            background-color: #333437;
        }

        pre {
            background-color: #333437;
        }

        h1, h2, hr {
            border-color: #404040;
        }

        th, td {
            border-color: #404040;
        }

        tr:hover td {
            background-color: #333437;
        }

        blockquote {
            border-left-color: #858585;

            &.info {
                border-left-color: rgb(27, 110, 134);
                color: rgb(98, 195, 223);
                background-color: rgb(19, 34, 42);
            }

            &.warning {
                background-color: rgb(49, 34, 11);
                border-color: rgb(147, 91, 12);
                color: rgb(241, 176, 84);
            }

            &.danger {
                color: rgb(219, 94, 90);
                background-color: rgb(46, 11, 11);
                border-color: rgb(137, 33, 30);
            }

            &.success {
                background-color: rgb(27, 39, 23);
                border-color: rgb(56, 122, 57);
                color: rgb(98, 183, 98);
            }
        }
    }

    ${e=>e.$css}
`;function Xe(e){let{as:t=l,children:n,components:i={},aside:a=!0,header:s,footer:d,css:p,sectionAs:g,inject:b=!0,loader:w=null,onShow:v,...x}=e;const k=u((()=>o().use(A).freeze()),[]),[y,E]=h(w),[C,$]=h(null);return Pe((async()=>{try{const e=await k.run(k.parse(n));$(e)}catch(e){console.warn(e),$(!1)}}),[n,k]),f((()=>{if(null!==C){if(!1===C)E(null);else if(C){const e=k.data("toHastExtensions");E(c(De,{value:i,children:[r(Ke,{tree:C,extensions:e,header:s,footer:d,as:g,css:p,inject:b}),r(Ue,{tree:C,extensions:e,options:a})]}))}v&&requestAnimationFrame(v)}}),[C,a,s,d,p,g,b]),m(t,x,y)}function Ye(e){let{onChange:t,onCompositionStart:o,onCompositionEnd:n,...i}=e;const c=w(!1),a=p((e=>{c.current||t?.(e)}),[t]),s=p((e=>{c.current=!0,o?.(e)}),[o]),l=p((e=>{c.current=!1,t?.(e),n?.(e)}),[n,t]);return r("input",{...i,onChange:a,onCompositionStart:s,onCompositionEnd:l})}function Ze(e){const t=w();return f((()=>{t.current=e}),[e]),t.current}function et(){const{config:e}=Y();return e.getValue("themeConfig")}function tt(e){const t=w(e);f((()=>(document.title=e,()=>{document.title=t.current})),[e])}function ot(e,t,o){const n=w(e),r=w(U(e,t,o));return f((()=>{n.current=e})),f((()=>{r.current=U((function(){n.current(...arguments)}),t,o)}),[t,o]),r.current}function nt(e,t,o){const n=w(e),r=w(q(e,t,o));return f((()=>{n.current=e})),f((()=>{r.current=q((function(){n.current(...arguments)}),t,o)}),[t,o]),r.current}function rt(){return k("options")}const it=new EventTarget;function ct(){return it}function at(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.document;if("string"==typeof e){e=(new DOMParser).parseFromString(e,"text/html")}const t=e.querySelector('script[type="application/payload+json"]');if(t)try{return JSON.parse(t.innerHTML)}catch{return{}}}var st=Object.freeze({__proto__:null,encode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return window.btoa(unescape(encodeURIComponent(e)))}catch(e){if(t)throw e;return""}},decode:function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(null===e)return"";try{return decodeURIComponent(escape(window.atob(e)))}catch(e){if(t)throw e;return""}}});function lt(){return"undefined"!=typeof window&&/Mac|iPod|iPhone|iPad/.test(window.navigator.platform)}export{Ye as CompositionInput,J as InjectedComponent,K as InjectedComponentSet,Xe as Markdown,ze as Plugin,st as base64,Ee as createApplication,X as createComponentDescriptor,oe as createStorageSlot,at as getPayload,je as getPublicPath,lt as isMac,ne as listStorageKeys,Ce as useActions,Pe as useAsyncEffect,Y as useBook,ot as useDebounce,tt as useDocumentTitle,ct as useEventTarget,we as useIntlContext,re as useLocalStorageState,Se as useModel,rt as useOptions,Ze as usePrevious,$e as useSelector,Me as useStateWithCallback,et as useThemeConfig,me as useThemeContext,nt as useThrottle};
//# sourceMappingURL=index.js.map
